import React, { useEffect } from 'react';

const AcoordBtns = (props) => {



    useEffect(() => {


    }, [])


    return (
        <div className={props.cs}>
            {/* {props.user.permiss == "admin" ? */}
            <div className={"acoordIcon acord1 pointing"}
                onClick={() => props.removeProd(props.index, props.proIndex)}>
                <i className="far fa-trash-alt theSecIconsColor onLeft" /></div>
            {/* : ""} */}

            {/* {props.user.permiss == "admin" ? */}
            {/* {props.proIndex != 0 && props.productsLength > 1 ?
                <div className={"acoordIcon acord2 pointing"}
                    onClick={() => props.setUpProd(props.index, props.proIndex)} title={"הקפץ למעלה"}>
                    <i className="far fa-caret-square-up theSecIconsColor onLeft" /></div> : ""
            } */}
            {/* : ""} */}

            {/* {props.user.permiss == "admin" ? */}
            {/* {props.proIndex < props.productsLength - 1 ?
                <div className={"acoordIcon acord3 pointing"}
                    onClick={() => props.setDownProd(props.index, props.proIndex)} title={"הקפץ למטה"}>
                    <i className="far fa-caret-square-down theSecIconsColor onLeft" /></div> : ""
            } */}
            {/* : ""} */}

            <div className={"btnIteminStock"}>
                <input type="button"
                    onClick={() => props.setInStock(props.index, props.proIndex)}
                    value={(props.product.inStock) ? "קיים במלאי" : "אין במלאי"}
                    className={(props.product.inStock) ? "InStock" : "notInStock"} />

                <input type="button"
                    onClick={() => props.setOkToDeliver(props.index, props.proIndex)}
                    value={(props.product.okToDeliver) ? "ניתן לשלוח" : "לא למשלוח"}
                    className={(props.product.okToDeliver) ? "InStock" : "notInStock"} />
            </div>
        </div>
    )
}

export default AcoordBtns;